import React from 'react';
import { Card, Col, Row, Button, Pagination } from 'react-bootstrap';
import './ProductList.css'; // Certifique-se de ter um arquivo CSS para os estilos

const ProductList = ({ products, page, totalPages, onPageChange }) => {
    const pageLimit = 10;
    const halfLimit = Math.floor(pageLimit / 2);
    
    const getPageNumbers = () => {
        let start = Math.max(1, page - halfLimit);
        let end = Math.min(totalPages, page + halfLimit);
        
        // Ajustar início e fim se o intervalo estiver muito perto das bordas
        if (end - start + 1 < pageLimit) {
            if (start === 1) {
                end = Math.min(totalPages, end + (pageLimit - (end - start + 1)));
            } else if (end === totalPages) {
                start = Math.max(1, start - (pageLimit - (end - start + 1)));
            }
        }

        const pageNumbers = [];
        for (let i = start; i <= end; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const pageNumbers = getPageNumbers();

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            onPageChange(newPage);
        }
    };

    return (
        <div>
            <Row>
                {products.map(product => (
                    <Col key={product.id} sm={12} md={6} lg={4} xl={3}>
                        <Card className="mb-4 shadow-sm product-card">
                            <Card.Img variant="top" src={product.thumbnail} className="card-img" />
                            <Card.Body>
                                <Card.Title className="product-title">{product.title}</Card.Title>
                                <Card.Text className="product-price">R${product.price.toFixed(2)}</Card.Text>
                                <Card.Text>
                                    <strong>Reputação do Vendedor:</strong>
                                    <div className="reputation-bar">
                                        <div
                                            className={`reputation-fill bg-${getReputationColor(product.sellerRating)}`}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </Card.Text>
                                <Card.Text>
                                    <strong>Nome do Vendedor:</strong> {product.sellerName}
                                </Card.Text>
                                <Card.Text>
                                    <strong>Localização:</strong> {product.sellerLocation}
                                </Card.Text>
                                {/* Exibir o nível do anúncio, se disponível */}
                                {product.adLevel && (
                                    <Card.Text>
                                        <strong>Nível do Anúncio:</strong> {product.adLevel}
                                    </Card.Text>
                                )}
                                <Button variant="primary" href={product.link} target="_blank">Ver Anúncio</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* Pagination Controls */}
            <div className="pagination-controls">
                <Pagination>
                    <Pagination.Prev 
                        onClick={() => handlePageChange(page - 1)} 
                        disabled={page === 1}
                    />
                    {page > 1 && (
                        <>
                            <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
                            {page > 2 && <Pagination.Ellipsis />}
                        </>
                    )}
                    {pageNumbers.map(num => (
                        <Pagination.Item
                            key={num}
                            active={num === page}
                            onClick={() => handlePageChange(num)}
                        >
                            {num}
                        </Pagination.Item>
                    ))}
                    {page < totalPages - 1 && <Pagination.Ellipsis />}
                    {totalPages > 1 && page < totalPages && (
                        <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                            {totalPages}
                        </Pagination.Item>
                    )}
                    <Pagination.Next 
                        onClick={() => handlePageChange(page + 1)} 
                        disabled={page === totalPages}
                    />
                </Pagination>
            </div>
        </div>
    );
};

// Função para determinar a cor da reputação
const getReputationColor = (rating) => {
    if (rating.includes('green')) {
        return 'success'; // cor verde
    } else if (rating.includes('yellow')) {
        return 'warning'; // cor amarela
    } else if (rating.includes('red')) {
        return 'danger'; // cor vermelha
    } else {
        return 'secondary'; // cor padrão
    }
};

export default ProductList;
